import DoubleEleven from './index';

export default { path: '/home/doubleEleven', component: DoubleEleven };
